const $ = jQuery.noConflict();

const normalizeInterval = (human) => {
  return human
    .replace('1W', '7D')
    .replace('1Y', '12M')
    .replace('5Y', '60M')
}

const tvMiniChartSwitcher = ($elements) => {
  $elements.each(function() {
    const $container = $(this);
    const frames = ($container.data('time-frames') || '1M').split(',')
    const $chart = $container.find('tv-mini-chart')
    const $selectTimeFrame = $("<div></div>").addClass('switcher')
    frames.forEach(frame => $('<a></a>').text(frame).attr({
      'data-frame': frame,
      href: '#',
    }).appendTo($selectTimeFrame))
    $selectTimeFrame.prependTo($container)
    $container.on('click', '.switcher a', function(e) {
      e.preventDefault()
      $container.find('.switcher a').removeClass('active')
      $(event.target).addClass('active')
      const frame = normalizeInterval($(event.target).data('frame'))
      console.debug('switching mini chart to', frame)
      $chart[0].timeFrame = frame
    })
    $selectTimeFrame.find(`a[data-frame='${$chart.attr('time-frame')}']`).addClass('active')
  })
}

export default tvMiniChartSwitcher;
